/**
 *
 * EmptyState
 *
 */

import React from 'react';
import { Result } from 'antd';

import Icon from '../Icon';
import './style.css';
// import PropTypes from 'prop-types';
// import styled from 'styled-components';

function EmptyState({ image, title, message, extra, ...rest }: any) {
  return (
    <Result
      {...rest}
      title={title}
      subTitle={message}
      extra={extra}
      icon={
        (
          <Icon
            style={{ width: '255px', height: '200px', objectFit: 'contain' }}
            type="emptyState"
            showPointer={false}
          />
        ) as any
      }
    />
  );
}

export default EmptyState;
